import { gql } from "@apollo/client";

export const GET_MASTER_DATA_DEDUCTION_CATEGORIES = gql`
  query MasterDataDeductionCategories(
    $params: MasterDataDeductionTypeCategoriesParamsInput!
  ) {
    masterDataDeductionCategories(params: $params) {
      items {
        categoryId
        categoryName
        categoryKey
        isActive
        isLinked
      }
    }
  }
`;
